export const platformDetails = {
    platform: 'de.iterate',
    version: '5.7.0',
    revision: 'r807-504dda6',
};

export const platformVersion = async (parentContainer = document.querySelector('#footer')) => {
    let paragraph = document.createElement('p');
    paragraph.textContent = `${platformDetails.platform} ${platformDetails.version} ${platformDetails.revision}`;
    console.log(parentContainer);
    parentContainer.insertAdjacentElement('afterbegin', paragraph);
};